import { useEffect, useState } from 'react';
import { apiFetch } from '../api';

/**
 * Globaler Wartungs-Banner.
 * Wird nur Organisationen außer SUPER/TESTORG angezeigt, wenn der Wartungsmodus aktiv ist.
 * Falls aktiv: zwingt einen Logout/Redirect zum Login.
 */
export default function MaintenanceBanner() {
  const org = (() => {
    try { return localStorage.getItem('organization') || ''; } catch { return ''; }
  })();
  const ALLOWED = ['SUPER', 'TESTORG'];

  const [enabled, setEnabled] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (ALLOWED.includes(org)) return; // diese Orgs sehen den Banner nie
    let cancelled = false;
    async function load() {
      try {
        const data = await apiFetch('/system/maintenance');
        if (cancelled) return;
        setEnabled(!!data?.enabled);
        setMessage(data?.message ?? null);
      } catch { /* ignore */ }
    }
    load();
    const id = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(id); };
  }, [org]);

  if (ALLOWED.includes(org)) return null;
  if (!enabled) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
      <div className="max-w-lg w-full bg-white dark:bg-gray-800 border-2 border-red-500 rounded-xl shadow-2xl p-6 text-center">
        <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-red-600 text-white flex items-center justify-center animate-pulse">
          <svg className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round"
              d="M12 9v3.75m0 3h.008v.008H12V15.75zM21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-xl font-bold text-red-700 dark:text-red-400">Wartungsarbeiten</h2>
        <p className="mt-2 text-gray-700 dark:text-gray-300">
          {message || 'Das System wird gerade gewartet. Bitte versuchen Sie es in Kürze erneut.'}
        </p>
        <button
          onClick={() => {
            try { localStorage.clear(); } catch {}
            window.location.href = '/';
          }}
          className="mt-5 px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
        >
          Abmelden
        </button>
      </div>
    </div>
  );
}
